import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.5" }, [
      _createElementVNode("path", { d: "M7 9.75L2.66987 4.125L11.3301 4.125L7 9.75Z" })
    ], -1)
  ]))]))
}
export default { render: render }